import React, { useCallback } from 'react'
import styled from 'styled-components'
import QRCode from 'react-qr-code'

import Flex from 'components/reusable/flex'
import Indent from 'components/reusable/indent'
import { BodyMain, H4 } from 'components/views/help/help_faq_v2/components/styled'
import Settings from 'helpers/settings'
import Button from 'components/reusable/button'
import SvgCrossMarkSolid from 'components/reusable/svg/svg_cross_mark_solid'
import useModalContext from 'hooks/use_modal_context'
import { modalEnum } from './modal'

const Wrapper = styled(Flex)`
  max-width: 480px;
  width: 100%;
  padding: 56px;
  position: relative;
  @media (max-width: 768px) {
    padding: 24px 16px 16px;
  }
`

const StyledButton = styled(Button)`
  position: absolute;
  top: 30px;
  right: 40px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

const AppQrCodeModal = ({ onClose }) => {
  const { onOpenModal } = useModalContext()

  const handleClose = useCallback(() => {
    onClose()
    onOpenModal(modalEnum.waitlistWelcome)
  }, [onClose, onOpenModal])

  return (
    <Wrapper dir="column" wrap="nowrap">
      <StyledButton type="semantic-wrapper" onClick={handleClose} aria-label="Close">
        <SvgCrossMarkSolid size={20} />
      </StyledButton>

      <H4>Thanks for Signing Up!</H4>
      <Indent bottom={12} />

      <BodyMain textAlign="center">
        Get the Swipecast app and never miss an opportunity. Stay connected to castings and messages in real-time:
      </BodyMain>
      <Indent bottom={32} />

      <QRCode size={200} value={Settings.appURL} viewBox={`0 0 256 256`} />
    </Wrapper>
  )
}

export default AppQrCodeModal
